import useScreenshotsStore from '@/src/store/screenshots';
import type {
  ApiIntegrationWithViewConfig,
  ApiMirrorRegistry,
} from '@fabric-app/types/connections';
import { useMutationMirrorRegistryForceSync } from '@fabric-app/business/connections/mutations/useMutationMirrorRegistryForceSync';
import { useMutationMirrorRegistryUpdate } from '@fabric-app/business/connections/mutations/useMutationMirrorRegistryUpdate';
import { toast } from '@fabric-app/business/store/alerts';
import { pick } from '@fabric-app/utils/object/manipulation';
import { MirrorStatus } from '@fabric/woody-client';
import { shallow } from 'zustand/shallow';

export const useMirrorRegistryForceSync = (args: {
  mirrorRegistry: ApiMirrorRegistry;
  integration: ApiIntegrationWithViewConfig;
}) => {
  const { integration, mirrorRegistry } = args;

  const mutationMirrorRegistryUpdate = useMutationMirrorRegistryUpdate();
  const mutationMirrorRegistryForceSync = useMutationMirrorRegistryForceSync();

  /**
   * data for device the app is running in
   */
  const { imageAccess, reset } = useScreenshotsStore(
    (state) => pick(state, ['imageAccess', 'reset']),
    shallow,
  );

  if (integration.viewConfig.isDeviceSync) {
    const uniqueId = 'uniqueId' in imageAccess ? imageAccess.uniqueId : null;

    if (uniqueId === integration?.externalId) {
      /**
       * if current device is the one we are syncing with
       * we send a fn to force sync
       */
      return async () => {
        if (mirrorRegistry.status !== MirrorStatus.ACTIVE) {
          await mutationMirrorRegistryUpdate.mutateAsync({
            mirrorRegistryId: mirrorRegistry.id,
            status: MirrorStatus.ACTIVE,
          });
        }
        reset();
        toast({
          content: 'Resync started',
        });
        return;
      };
    }
  } else {
    return async () => {
      toast({
        content: 'Resync started',
      });
      return mutationMirrorRegistryForceSync.mutateAsync({ mirrorRegistry });
    };
  }
};
